"use client"
import { LogInImageBox } from "features/login/LogInImageBox"
import type React from "react"

import { Flex, Hide } from "@chakra-ui/react"

interface LoginWrapperProps {
    children: React.ReactNode
}

const LoginWrapper: React.FC<LoginWrapperProps> = ({ children }) => (
    <Flex
        /*
         * Dev Note: Styling looks strange in the flex direction below, but it is purposeful.
         * The image graphic was appearing for a split second on load, so positioning it beneath the log in component hides it from view.
         * Then on large screens we pop the image on top of the log in
         * And on XL and above screens we position the components in a row
         */
        flexDir={{ base: "column", lg: "column-reverse", xl: "row" }}
        minH={96}
        p={{ base: 0, lg: 6, xl: 8 }}
        alignItems={{ base: "flex-start", xl: "center" }}
        gap={{ base: 12, md: 16, xl: 0 }}
        overflowY='scroll'
    >
        <Flex
            w={{ base: "full", xl: "50%" }}
            flexDir='column'
            h={{ base: "100vh", lg: "full" }}
            alignItems='center'
            justifyContent={{ base: "center", lg: "flex-start" }}
        >
            <Flex flexDir='column' w='full' alignItems='center' h='full'>
                {children}
            </Flex>
        </Flex>
        <Hide below='lg'>
            <LogInImageBox />
        </Hide>
    </Flex>
)

export default LoginWrapper
